import InfiniteScrollTableView from './InfiniteScrollTableView';
export default InfiniteScrollTableView;
